import React from 'react';
import { useState } from 'react';
import {Image} from 'antd'


const DictionaryQuestion = (props) =>  {
    const data = props.question;

    return (
        <div className="p-4">
            {
                data.map(res=>{
                    return (
                        <div>
                        {
                            res?.type==='text'?<span style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>{res.text}</span>:
                                <Image src={res.image_url} width={100}></Image>
                        }
                        </div>
                    )
                })
            }

        </div>
    );
}





export default DictionaryQuestion
